import { MarketingPage, Section } from './MarketingPage'

/**
 * M00-10 — legal pages.
 *
 * These are placeholders with the correct structure and routes, clearly marked as
 * pending legal review. Inventing plausible-sounding privacy or contract text
 * would be worse than an obvious placeholder: someone would ship it.
 */
export function LegalPage({ document }: { document: 'privacy' | 'terms' }) {
  const isPrivacy = document === 'privacy'

  return (
    <MarketingPage
      title={isPrivacy ? 'Privacy Policy' : 'Terms of Service'}
      lede="This document is pending review by legal counsel and must not be published as-is."
    >
      <div className="rounded-md border border-state-warning-border bg-state-warning-surface p-4 text-body-sm text-state-warning">
        Placeholder content. Launch readiness requires the reviewed text before this page goes live.
      </div>

      {isPrivacy ? (
        <>
          <Section heading="What we collect">
            <p className="text-body-sm text-text-secondary">
              Account details, workspace content you upload, and respondent data collected on your
              behalf as a data processor. Respondent PII is stripped from exports.
            </p>
          </Section>
          <Section heading="Retention and deletion">
            <p className="text-body-sm text-text-secondary">
              Respondent deletion requests are actioned within 72 hours. Workspace data is retained
              for the life of the contract and deleted on request afterwards.
            </p>
          </Section>
          <Section heading="Cookies">
            <p className="text-body-sm text-text-secondary">
              Only strictly necessary cookies: your theme preference and sign-in state. No
              advertising or cross-site tracking cookies are set.
            </p>
          </Section>
        </>
      ) : (
        <>
          <Section heading="Use of the platform">
            <p className="text-body-sm text-text-secondary">
              Access is licensed per workspace. Research outputs are yours; the platform, models and
              methodology remain ours.
            </p>
          </Section>
          <Section heading="AI-generated content">
            <p className="text-body-sm text-text-secondary">
              Outputs are AI-generated and reviewed by a Research Lead where indicated. Simulated
              persona responses are not real consumer data and are labelled as such wherever they
              appear, including in exports.
            </p>
          </Section>
          <Section heading="Licensed data">
            <p className="text-body-sm text-text-secondary">
              Content sourced from paid databases is marked in the interface and may carry
              redistribution restrictions.
            </p>
          </Section>
        </>
      )}
    </MarketingPage>
  )
}
